import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-research-and-publication',
  templateUrl: './research-and-publication.component.html',
  styleUrls: ['./research-and-publication.component.scss']
})
export class ResearchAndPublicationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
